import useAsyncData from "../../../../hooks/use-async-data";
import driverService from "../../driver.service";
import DriverPlanList from "./driver-plan-list";
import DriverPlanListError from "./driver-plan-list-error";
import DriverPlanListParams from "./driver-plan-list-params";

const useDriverPlanList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<DriverPlanList>({ entries: [] });

  const load = async (
    params: DriverPlanListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverPlan = await driverService.getPlanList(params, signal);

      setData(driverPlan);
    } catch (_error) {
      const error = _error as DriverPlanListError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverPlanList;
